import { render } from "./Waypoint.vue?vue&type=template&id=6b6b5afe&bindings={\"wayPoint\":\"props\",\"dialogue\":\"data\",\"card\":\"data\",\"renderContent\":\"options\"}"
import script from "./Waypoint.vue?vue&type=script&lang=js"
export * from "./Waypoint.vue?vue&type=script&lang=js"
script.render = render

export default script